import { useState } from 'react';
import { useQuery } from 'react-query';
import clinicService from '../services/clinic.service';

const useIntegrations = (clinicId: number) => {
  const [saving, setSaving] = useState(false);

  const { data, isFetching, refetch } = useQuery<{ data: any[] }>(
    'integrations',
    () => clinicService.listIntegrations(clinicId),
    { refetchOnWindowFocus: false }
  );

  const activateIntegration = async (integrationId: number, active: boolean) => {
    try {
      setSaving(true);
      await clinicService.activeIntegration(clinicId, integrationId, active);
      refetch();
    } catch (e) {
      console.error(e);
    } finally {
      setSaving(false);
    }
  };

  return { isFetching, data, refetch, activateIntegration, saving };
};

export default useIntegrations;
